import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_billing_contract_line_details_validationService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { contractId?: number, lineIds?: number[], strategyName?: string }): 
  Promise<{ result: { BillingContractLineId?: number, StrategyFieldName?: string, SerializedValueEntity?: string, Value?: string }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { contractId?: number, lineIds?: number[], strategyName?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { BillingContractLineId?: number, StrategyFieldName?: string, SerializedValueEntity?: string, Value?: string }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { contractId?: number, lineIds?: number[], strategyName?: string, $keys: { BillingContractLineId?: number, StrategyFieldName?: string }[] }): 
  Promise<{ result: { BillingContractLineId?: number, StrategyFieldName?: string, SerializedValueEntity?: string, Value?: string }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      contractId?: number, lineIds?: number[], strategyName?: string    }) {
      return false;
    }
}
